import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import './Footer.css';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/contact" className="footer-link">{t('footer.contact')}</Link>
          <span className="footer-separator">|</span>
          <Link to="/privacy-policy" className="footer-link">{t('footer.privacyPolicy')}</Link>
          <span className="footer-separator">|</span>
          <Link to="/terms-of-use" className="footer-link">{t('footer.termsOfUse')}</Link>
        </div>
        <div className="footer-copyright">
          © {new Date().getFullYear()} Seaing You. {t('footer.copyright')}
          <br />
          {t('footer.kvk')}: 98698842
        </div>
      </div>
    </footer>
  );
};

export default Footer;
